import Stack from "@mui/material/Stack";

import { NotificationRecipients } from "@/pages/billing/v2/tabs/alertSetting/NotificationRecipients";
import { UsageLimitTable } from "@/pages/billing/v2/tabs/alertSetting/UsageLimitTable";

export const AlertSettingTab: React.FC = function AlertSettingTab() {
  return (
    <Stack gap="32px">
      <NotificationRecipients />
      <UsageLimitTable />
    </Stack>
  );
};
